import { render, staticRenderFns } from "./WhatsappAPI.vue?vue&type=template&id=66caf3db&"
import script from "./WhatsappAPI.vue?vue&type=script&lang=js&"
export * from "./WhatsappAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports